import React from 'react';

import { toolbarSwatchStyle } from './toolbar-styles';

export type AnnotationSwatchGridProps = {
	colors: Array<string>;
	selected: string | null;
	onPick: (color: string) => void;
};

/** One row shape for every palette in the picker, so recents, ink and tints cannot drift apart */
export const AnnotationSwatchGrid = (props: AnnotationSwatchGridProps): React.ReactElement => {
	const { colors, selected, onPick } = props;

	return (
		<div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '4px' }}>
			{colors.map((color) => (
				<button
					key={color}
					type="button"
					title={color}
					aria-label={color}
					onClick={() => onPick(color)}
					style={toolbarSwatchStyle({ color, isSelected: (selected ?? '').toLowerCase() === color.toLowerCase() })}
				/>
			))}
		</div>
	);
};
